<template>
    <div>
        <p>{{ colorName }}</p>
    </div>
    <div class="colored-box" :style="coloredBoxStyle"></div>
</template>

<script>
import {PubSub} from 'aws-amplify';
import {computed, ref} from 'vue';

export default {
    name: 'App',
    setup() {
        const ntc = require('ntcjs');
        let boxColor = ref('#777777')
        const coloredBoxStyle = computed(() => {
            return {
                backgroundColor: boxColor.value,
            }
        })
        const colorName = computed(() => {
            console.log(`BoxColor is ${boxColor.value}`)
            let colorNameMatch = ntc.name(boxColor.value);
            console.log(colorNameMatch)
            return colorNameMatch[1]
        })
        PubSub.subscribe('colorsensor/thingName/colordata', {provider: 'AWSIoTProvider'}).subscribe({
            next: data => {
                console.log('Data Message received', data);
                boxColor.value = data.value.hex_value;
            },
            error: (error) => {
                console.log('Error Message received', error);
            },
            close: () => {
                console.log('Closing connection');
            }
        })

        return {coloredBoxStyle, colorName}
    }
}
</script>

<style scoped>
.colored-box {
    height: 100vh;
    width: 100vw;
}
</style>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
</style>
